// Constantes compartilhadas do site
export const WHATSAPP_NUMBER = "5575981872440";

export const waLink = (msg) => {
  const defaultMsg = "Olá, vim do site e gostaria de agendar uma avaliação de derrame pleural com dr. Mateus";
  const message = msg || defaultMsg;
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
};

export const PHOTO_HERO =
  "https://customer-assets.emergentagent.com/job_simpatectomia-feira/artifacts/yd7yn43y_AMO%20161%20-%20co%CC%81pia.JPG";

export const PHOTO_ABOUT =
  "https://customer-assets.emergentagent.com/job_simpatectomia-feira/artifacts/htkofdla_AMO%20173%20-%20co%CC%81pia.JPG";

export const LOGO_URL = "/images/logo-mateus.webp";
export const INSTAGRAM_URL = "https://instagram.com/drmateus_cirtorax";

export const HOSPITAL_BG =
  "https://images.unsplash.com/photo-1516549655169-df83a0774514?auto=format&fit=crop&w=1600&q=70&blur=40";

export const LUNG_ILLUSTRATION = "/images/lung-pleural-effusion.webp";

export const CONVENIOS = [
  { name: "Bradesco Saúde", slug: "bradesco" },
  { name: "Amil", slug: "amil" },
  { name: "Cassi", slug: "cassi" },
  { name: "Asfeb", slug: "asfeb" },
  { name: "Fusex", slug: "fusex" },
  { name: "GEAP Saúde", slug: "geap" },
  { name: "Petrobras", slug: "petrobras" },
  { name: "Planserv", slug: "planserv" },
  { name: "Postal Saúde", slug: "postal" },
  { name: "SulAmérica", slug: "sulamerica" },
  { name: "Saúde Caixa", slug: "saudecaixa" },
  { name: "União Médica", slug: "uniaomed" },
  { name: "Unimed", slug: "unimed" },
];

export const CONVENIO_LOGO_BASE =
  "https://simpatectomia-feira.preview.static.emergentagent.com/images/logos";

export const GOOGLE_REVIEWS_LINK = "https://share.google/BljsumTZh1DHam1jU";
